import cx from 'classnames';
import React, { memo, useEffect, useMemo, useState } from 'react';
import { Download, FooterButton, Preview } from '../common';
import {
  ADMIN_DASHBOARD,
  RENDERS_PREVIEWS_ROUTE,
  RENDERS_PREVIEWS_ROUTE_V2,
  RENDER_DETAILS,
  RENDER_DETAILS_V2,
  SHARED_FILES_ROUTE,
} from '../constants/routePathConstants';
import { getCollectionPath } from '../helpers/urlHelper';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { apiGetPreviewAndMainRender, apiGetRenderBasedOnProjectRenderId } from '../helpers/api';
import _ from 'lodash';
import { Form } from 'react-bootstrap';
import { DOWNLOAD_ICON } from '../constants/assetConstants';
import { icons } from '../assets';
import constants from '../constants/constants';
const { FullScreenIcon } = icons;
import { errorToast, warningToast } from '../helpers/toastHelper';
import { RenderPageDialog } from '../common';
import { setTitle } from '../helpers/jsHelper';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from '../../node_modules/jszip-utils/dist/jszip-utils.js';
import { FinalRenderIcon } from '../components/icons/FinalRenderIcon';
import { useUserContext } from '../contexts/UserContext';
import { useDispatch } from 'react-redux';
import AddToCollectionPopup from '../common/AddToCollectionPopup';
import { useInfoDialogaActions } from '../hooks/useInfoDialogaActions';
import { usePermissionsHandler } from '../hooks/usePermissions';
import { PERMISSION } from '../constants/permissionConstants';
import { download } from '../common/DownloadFileController/downloadFile';
import { getAppState } from '../redux/store';
import { useDataListContext } from '../contexts/DataListContext';
import Loader from '../components/Loader/Loader';
const { RENDER_STATUS } = constants;

const PASS = {
  STANDARD: '1',
  FILMIC: '2',
  COLOR: '3',
};
const IMAGE_TYPE = {
  STANDARD: 'standard',
  FILMIC: 'filmic',
  COLOR: 'color pass',
};

const AutomationTemplateImages = memo(
  ({
    id,
    onClose,
    theme,
    sidebarProps,
    previewProps,
    hideAutoEraseWarning,
    onDataFetched,
    onRenderSuccess,
    ignoreAddToCollectionPopup,
    onRenderSwitch,
  }) => {
    const dataListContext = useDataListContext();
    const navigate = useNavigate();
    const params = useParams();
    id = id || params.renderId;
    const collectionId = params.collectionId;
    const [pageLoading, setPageLoading] = useState(false);
    const { currentUser } = useUserContext();
    const userName = currentUser?.user?.name;
    const currentOrg = currentUser?.organization;
    const [data, setData] = useState(null);
    const [cameraList, setCameraList] = useState([]);
    const [slides, setSlides] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeCameraId, setActiveCameraId] = useState(null);
    const [loading, setLoading] = useState(false);
    // const [showComments, setShowComments] = useState(false);
    const [isDownloadSingleImage, setDownloadSingleImage] = useState(false);
    const [pass, setPass] = useState('1');
    const [showDownload, setShowDownload] = useState(false);
    const [showRender, setShowRender] = useState(false);
    const [downloadXPos, setDownloadXPos] = useState(0);
    const [includePasses, setIncludePasses] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [renderedData, setRenderedData] = useState(null);
    const [imageUrl, setImageUrl] = useState([]);
    const [isFullScreenOn, setFullScreenOn] = useState(false);
    const { openInfoDialog } = useInfoDialogaActions();

    const [memberDetails, setMemberDetails] = useState({});

    const { handlePermissionEvent } = usePermissionsHandler();

    const [searchParams, setSearchParams] = useSearchParams();
    const render_type = searchParams.get('render_type');
    const cameraNameParam = searchParams.get('cameraName');
    const organization = searchParams.get('organization');

    const sidebarCards = useMemo(() => {
      return data?.images ? data.images.map((image) => ({ ...image, name: image.angle_name })) : [];
    }, [data]);

    const isUpload = data?.is_upload;
    let passOptions = [];

    if (data?.images && data.images.length > 0 && !isUpload && !render_type) {
      const image = data?.images?.[activeIndex];
      const isFilmic = image.is_filmic;
      if (image?.file)
        passOptions.push({ name: isFilmic ? 'Standard' : 'Standard *', value: PASS.STANDARD });
      if (image.filmic_file)
        passOptions.push({ name: isFilmic ? 'Filmic *' : 'Filmic', value: PASS.FILMIC });
      if (image.color_pass_file) passOptions.push({ name: 'Color', value: PASS.COLOR });
    }

    const closeDialog = () => navigate(ADMIN_DASHBOARD);

    const resetState = () => {
      setActiveIndex(0);
      setCameraList([]);
      setSlides([]);
      setActiveCameraId(null);
      setDownloadSingleImage(false);
      setPass('1');
      setShowDownload(false);
      setShowRender(false);
      setDownloadXPos(0);
      setIncludePasses(false);
      setDownloadLoading(false);
      setRenderedData(null);
      setFullScreenOn(false);
    };

    useEffect(() => {
      if (organization && currentOrg.toString() !== organization.toString()) {
        openInfoDialog({
          onClose: closeDialog,
          title: 'Not Found',
          description:
            'This render/preview was created from a different organization. Please switch your organization to see this render.',
          buttonText: 'Go to Home',
          onButtonClick: () => closeDialog(),
        });

        return;
      }

      if (parseInt(id) !== data?.id) {
        // TODO: we can do it based on render list data??? but it's only related to render page
        refreshData();
      }
    }, [id]);

    useEffect(() => {
      if (data?.images) {
        setSlidesByPass();
      }
    }, [data]);

    useEffect(setSlidesByPass, [pass]);

    useEffect(() => {
      const isFilmic = data?.images?.[activeIndex].is_filmic;
      setPass(isFilmic ? PASS.FILMIC : PASS.STANDARD);
    }, [activeIndex]);

    useEffect(() => {
      if (activeCameraId) {
        const angleName = sidebarCards.find((a) => a?.id === activeCameraId)?.angle_name;

        if (angleName) {
          searchParams.set('cameraName', angleName);
          setSearchParams(searchParams, { replace: true });
        }

        if (cameraNameParam) {
          const cameraIndex = sidebarCards.findIndex((a) => a?.id === activeCameraId);
          if (cameraIndex !== -1 && cameraIndex !== activeIndex) {
            setActiveIndex(cameraIndex);
          }
        }
      }
    }, [activeCameraId]);

    function setSlidesByPass() {
      if (pass === PASS.STANDARD) {
        setSlides(_.map(data?.images, (i) => (i.is_tiff ? i.extra_file : i.file)));
      } else if (pass === PASS.FILMIC) {
        setSlides(_.map(data?.images, (i) => (i.is_tiff ? i.extra_filmic_file : i.filmic_file)));
      } else if (pass === PASS.COLOR) {
        setSlides(
          _.map(data?.images, (i) => (i.is_tiff ? i.extra_color_pass_file : i.color_pass_file))
        );
      }
    }

    function handleDownloadClick(e) {
      e.stopPropagation();
      setDownloadLoading(true);
      handlePermissionEvent(PERMISSION.DOWNLOAD_RENDER, (r) => {
        setDownloadLoading(false);
        if (r === undefined) {
          setDownloadXPos(isFullScreenOn ? e.clientX : e.clientX - 232);
          setShowDownload(!showDownload);
        }
      })().finally(() => setDownloadLoading(false));
    }

    useEffect(() => {
      if (!showDownload) {
        setImageUrl([]);
      }
    }, [showDownload]);

    var zip = new JSZip();
    var zipName = data?.name;

    async function setAngleImageUrl(arr) {
      arr?.map((a, i) => {
        if (a?.file !== null) {
          const u = a?.file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];

          setImageUrl((imageUrl) => [
            ...imageUrl,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType: IMAGE_TYPE.STANDARD,
              filename: filename,
              url: a?.file,
            },
          ]);
        }
        if (a?.filmic_file !== null) {
          const u = a?.filmic_file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];

          setImageUrl((imageUrl) => [
            ...imageUrl,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType: IMAGE_TYPE.FILMIC,
              filename: filename,
              url: a?.filmic_file,
            },
          ]);
        }
        if (a?.color_pass_file !== null) {
          const u = a?.color_pass_file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];

          setImageUrl((imageUrl) => [
            ...imageUrl,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType: IMAGE_TYPE.COLOR,
              filename: filename,
              url: a?.color_pass_file,
            },
          ]);
        }
      });
    }

    const handleCurrentImageClick = async () => {
      setDownloadSingleImage(true);
      setDownloadLoading(true);
      setAngleImageUrl(_.filter(data?.images, (a) => a.id === activeCameraId));
    };

    useEffect(() => {
      if (isDownloadSingleImage && !includePasses) {
        imageUrl?.length !== 0 &&
          imageUrl.forEach(function (imgObj, i) {
            const fileUrl = imgObj.url;
            const angle_name = imgObj.angle_name;
            const imageType = imgObj.imageType;
            const ext = imgObj.filename.split('.').pop();

            const fileName = `${zipName}_${angle_name}_${imageType}.${ext}`;

            if (imageType === IMAGE_TYPE.STANDARD && pass === PASS.STANDARD) {
              download({ fileUrl, fileName });
            }
            if (imageType === IMAGE_TYPE.FILMIC && pass === PASS.FILMIC) {
              download({ fileUrl, fileName });
            }
            if (imageType === IMAGE_TYPE.COLOR && pass === PASS.COLOR) {
              download({ fileUrl, fileName });
            }
          });

        setImageUrl([]);
        setDownloadLoading(false);
        setDownloadSingleImage(false);
        setShowDownload(false);

        return;
      }

      if (imageUrl?.length !== 0) {
        let count = 0;

        imageUrl.forEach(function (imgObj, i) {
          let url = imgObj.url;
          let angle_name = imgObj.angle_name;
          let imageType = imgObj.imageType;
          let ext = imgObj.filename.split('.').pop();

          let filename = `${zipName}_${angle_name}_${imageType}.${ext}`;

          JSZipUtils.getBinaryContent(url, function (err, data) {
            if (err) {
              throw err; // or handle the error
            }
            if (includePasses) {
              if (imageType === IMAGE_TYPE.STANDARD) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.FILMIC) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.COLOR) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
            } else {
              if (imageType === IMAGE_TYPE.STANDARD && pass === PASS.STANDARD) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.FILMIC && pass === PASS.FILMIC) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.COLOR && pass === PASS.COLOR) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
            }
            count++;
            if (count === imageUrl.length) {
              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipName);
                setImageUrl([]);
                setDownloadLoading(false);
                setShowDownload(false);
                count = 0;
              });
            }
          });
        });
      }
    }, [imageUrl]);

    const handleAllCameraRendersDownloadClick = async () => {
      setDownloadSingleImage(false);
      setDownloadLoading(true);
      await setAngleImageUrl(data?.images);
    };

    async function refreshData(data) {
      if (loading) return;
      setLoading(true);

      const param = render_type === 'archive' ? '?is_archived=true' : '';

      const res = data || (await apiGetPreviewAndMainRender(id, null, null, param));

      if (res) {
        setData(res);

        const cc = cameraNameParam && res?.images.find((a) => a?.angle_name === cameraNameParam);
        setActiveCameraId(cc?.id || res?.images[0].id);
        setPass(res?.images[0]?.is_filmic ? PASS.FILMIC : PASS.STANDARD);
        setMemberDetails(res?.member_details);
        onDataFetched?.(res);
      } else {
        navigate(RENDERS_PREVIEWS_ROUTE_V2);
      }

      setLoading(false);

      const resCam = await apiGetRenderBasedOnProjectRenderId(id);
      if (resCam.status) {
        setTitle(resCam?.data?.result?.render_name);
        setRenderedData(resCam?.data?.result);
      }
    }

    function toggleRenderArea(e) {
      if (typeof renderedData === 'string') {
        errorToast(renderedData);
      } else {
        const updatedList = renderedData?.CameraData?.map((c) => ({
          ...c,
          resoX: parseInt(c.resoX),
          resoY: parseInt(c.resoY),
        }));
        setCameraList(updatedList);
        setShowRender(true);
      }
    }

    const renderNotReady = () =>
      warningToast('Your Render is not ready yet. You can download it when it is ready.');

    const isActiveCameraReady = () => {
      const currentCamStatus = sidebarCards.find((a) => a?.id === activeCameraId);
      return currentCamStatus?.status === RENDER_STATUS.STATUS_DONE;
    };

    const showRenderOrDownload = data?.is_preview
      ? {
          element: FooterButton,
          footerButton: isActiveCameraReady() && !render_type,
          title: 'Render',
          icon: FinalRenderIcon,
          clickFunction: (e) => toggleRenderArea(e),
          seq: 1,
        }
      : {
          element: Download,
          footerButton: isActiveCameraReady() && !render_type,
          isDisabled: !isActiveCameraReady(),
          isDisabledCallback: renderNotReady,
          title: 'Download',
          iconSrc: DOWNLOAD_ICON,
          loading: downloadLoading,
          clickFunction: (e) => handleDownloadClick(e),
          seq: 1,
        };

    const actions = [
      {
        ...showRenderOrDownload,
      },
      {
        element: FooterButton,
        footerButton: isActiveCameraReady() && !render_type,
        icon: FullScreenIcon,
        title: 'Full Screen',
        seq: 7,
      },
    ].filter(Boolean);

    const updatedAt = useMemo(() => {
      if (!data?.updated_at) return null;
      return new Date(data?.updated_at).getTime();
    }, [data?.updated_at]);

    const handleClose = () => {
      if (onClose) {
        onClose();
        return;
      }

      const params = new URLSearchParams(location.search);
      params.delete('cameraName');

      if (location.pathname.startsWith('/collection')) {
        navigate(getCollectionPath(collectionId, { params }));
      } else if (location.pathname.startsWith(SHARED_FILES_ROUTE)) {
        navigate(SHARED_FILES_ROUTE + '?' + params);
      } else {
        navigate(RENDERS_PREVIEWS_ROUTE_V2 + '?' + params);
      }
    };

    const hasMetadata = renderedData?.roomMetadata
      ? Object.values(renderedData?.roomMetadata || {}).length > 0
      : false;

    const hideDownloadActions = () => {
      setShowDownload(false);
      setIncludePasses(false);
    };

    useEffect(() => {
      window.addEventListener('keydown', hideDownloadActions);
      window.addEventListener('click', hideDownloadActions);
      return () => {
        window.addEventListener('keydown', hideDownloadActions);
        window.removeEventListener('click', hideDownloadActions);
      };
    }, []);

    const handleNextClick = async () => {
      // TODO: add check if we're on renders preview page ???? or pass some argument in query which determines which pagination list we want to use
      // TODO: when page loads we need some time to load results for renders/previews page -> we need to wait for event of some kind or something else

      if (!dataListContext) {
        return true;
      }

      if (activeIndex !== slides?.length - 1) {
        // allow to go to next slide
        return true;
      }

      let renderList = dataListContext.selectList(getAppState());
      const currentIndex = renderList.findIndex((item) => item.id === data.id);

      const nextIndex = currentIndex === -1 ? 0 : currentIndex + 1;
      let nextRender = renderList[nextIndex];

      if (!nextRender && !dataListContext.hasMore) {
        return activeIndex !== slides?.length - 1;
      }

      if (!nextRender) {
        setPageLoading(true);
        await dataListContext.fetchMoreData();
        setPageLoading(false);
        renderList = dataListContext.selectList(getAppState());
        nextRender = renderList[nextIndex];
      }

      const params = new URLSearchParams(location.search);
      params.delete('cameraName');
      resetState();
      refreshData(nextRender);
      setActiveIndex(0);
      setActiveCameraId(nextRender.images[0].id);

      if (onRenderSwitch) {
        onRenderSwitch(nextRender);
      } else {
        const url = (RENDER_DETAILS_V2 + `?${params}`).replace(':id', nextRender.id);
        navigate(url);
      }
      return false;
    };

    const handlePrevClick = async () => {
      // TODO: add check if we're on renders preview page ???? or pass some argument in query which determines which pagination list we want to use
      // TODO: when page loads we need some time to load results for renders/previews page -> we need to wait for event of some kind or something else

      if (!dataListContext) {
        return true;
      }

      if (activeIndex !== 0) {
        // allow to go to prev slide
        return true;
      }

      let renderList = dataListContext.selectList(getAppState());
      const currentIndex = renderList.findIndex((item) => item.id === data.id);

      // let nextIndex = currentIndex === -1 ? 0 : currentIndex - 1;
      // nextIndex = Math.max(nextIndex, 0);
      let prevRender = renderList[currentIndex - 1];

      if (!prevRender) {
        return activeIndex !== 0;
      }

      const params = new URLSearchParams(location.search);
      params.delete('cameraName');
      resetState();
      refreshData(prevRender);

      const newActiveIndex = prevRender.images.length - 1;
      setActiveIndex(newActiveIndex);
      setActiveCameraId(prevRender.images[newActiveIndex].id);

      if (onRenderSwitch) {
        onRenderSwitch(prevRender);
      } else {
        const url = (RENDER_DETAILS_V2 + `?${params}`).replace(':id', prevRender.id);
        navigate(url);
      }
      return false;
    };

    const hasData = Boolean(data);
    const isTransparentBg = Boolean(renderedData?.is_transparent_bg);
    let hideNextButton = hasData && data.images?.length < 2;
    let hidePrevButton = hasData && data.images?.length < 2;

    if (dataListContext) {
      const list = dataListContext.list;
      const lastRender = list[list.length - 1];
      hideNextButton =
        Boolean(lastRender) &&
        Boolean(data) &&
        lastRender.id === data.id &&
        !dataListContext.hasMore;

      const firstRender = list[0];
      hidePrevButton =
        Boolean(firstRender) && Boolean(data) && firstRender.id === data.id && activeIndex === 0;
    }

    return (
      <>
        <Loader
          portal
          loading={pageLoading}
          position="fixed"
          zIndex={4000}
          backdrop
          backdropColor="rgba(255, 255, 255, 0.2)"
        />
        <Preview
          id={data?.id}
          title={data?.name}
          activeCameraName={sidebarCards.find((a) => a?.id === activeCameraId)?.angle_name}
          actions={data ? actions : []}
          onClose={handleClose}
          loading={loading}
          updatedAt={updatedAt}
          created_at={data?.updated_at}
          userName={userName || null}
          sidebarCards={sidebarCards}
          slides={_.map(slides, (s) => (s ? s : ''))}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          activeCameraId={activeCameraId}
          setActiveCameraId={setActiveCameraId}
          passOptions={isActiveCameraReady() && passOptions}
          pass={pass}
          theme={theme}
          setPass={setPass}
          isTransparentBg={isTransparentBg}
          memberDetails={memberDetails}
          sidebarProps={sidebarProps}
          previewProps={previewProps}
          hideAutoEraseWarning={hideAutoEraseWarning}
          onNextClick={handleNextClick}
          onPrevClick={handlePrevClick}
          hideNextButton={hideNextButton}
          hidePrevButton={hidePrevButton}
          setFullScreenOn={setFullScreenOn}>
          {showDownload && (
            <div
              className="download-popup text-light"
              style={{ left: downloadXPos - 170 }}
              onClick={(e) => e.stopPropagation()}>
              <button role="button" onClick={handleCurrentImageClick} className="">
                Current Image
              </button>
              {sidebarCards.length > 1 && (
                <button
                  role="button"
                  disabled={data?.status !== RENDER_STATUS.STATUS_DONE}
                  className={cx(data?.status !== RENDER_STATUS.STATUS_DONE && 'disabled')}
                  onClick={() => handleAllCameraRendersDownloadClick()}>
                  All Camera Renders
                </button>
              )}
              <hr className="m-0 p-0" />
              <button className="d-flex justify-content-between noAction">
                <div className="">
                  <a>Include Passes</a>
                </div>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  value={includePasses}
                  checked={includePasses}
                  onChange={(e) => setIncludePasses(e.target.checked)}
                />
              </button>
            </div>
          )}
        </Preview>
        {showRender &&
          data !== undefined &&
          data !== null &&
          data?.images?.length > 0 &&
          cameraList !== undefined &&
          cameraList !== null &&
          cameraList?.length > 0 && (
            <RenderPageDialog
              render_id={id}
              cameraData={cameraList}
              showRender={showRender}
              setShowRender={setShowRender}
              hasMetadata={hasMetadata}
              onRenderSuccess={onRenderSuccess}
            />
          )}
        {!ignoreAddToCollectionPopup && <AddToCollectionPopup />}
      </>
    );
  }
);

export default AutomationTemplateImages;
